import { Button, Box } from "@mui/material";

const onClick = () => {
  document.location.href = "/advanced-variable-game";
  console.log("Play Advanced Variable Game Clicked");
};

const AdvancedVariableGameInfo = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h3>How to Play - Advanced Variable Game</h3>

      <p>
        <strong>Objective:</strong> Memorize the values assigned to{" "}
        <strong>A, B, and C</strong> with{" "}
        <strong>multiple complex relationships</strong> and correctly recall
        them when prompted.
      </p>

      <h4>Game Flow:</h4>
      <ul>
        <li>
          The game will display three variables <strong>A, B, and C</strong>,
          each assigned a <strong>random number between 1 and 9</strong> OR a{" "}
          <strong>relationship to another variable</strong>.
        </li>
        <li>
          You will see the values for <strong>A, B, and C</strong> one by one.
        </li>
        <ul>
          <li>
            <em>Example Round 1 (Simple):</em>
          </li>
          <li>
            A = <strong>5</strong> (displayed first)
          </li>
          <li>
            B = <strong>A + 2</strong> (displayed next - you must calculate: 5 +
            2 = 7)
          </li>
          <li>
            C = <strong>3</strong> (displayed last)
          </li>
        </ul>
        <ul>
          <li>
            <em>Example Round 2 (Complex):</em>
          </li>
          <li>
            A = <strong>B - 1</strong> (displayed first - remember this
            relationship!)
          </li>
          <li>
            B = <strong>4</strong> (displayed next - now you can calculate A = 4
            - 1 = 3)
          </li>
          <li>
            C = <strong>B + 3</strong> (displayed last - you must calculate: 4 +
            3 = 7)
          </li>
        </ul>
        <li>
          After all values are shown, the screen will clear, and you will be
          prompted with a random variable.
        </li>
        <li>
          <strong>Your task:</strong> Enter the correct number that was
          calculated for the prompted variable.
        </li>
        <ul>
          <li>
            <em>For Example Round 2:</em>
          </li>
          <li>
            The screen asks: <strong>"C = ?"</strong> → You type{" "}
            <strong>7</strong> (since C was B + 3 = 4 + 3 = 7)
          </li>
          <li>
            The screen asks: <strong>"A = ?"</strong> → You type{" "}
            <strong>3</strong> (since A was B - 1 = 4 - 1 = 3)
          </li>
          <li>
            The screen asks: <strong>"B = ?"</strong> → You type{" "}
            <strong>4</strong>
          </li>
        </ul>
        <li>
          You will repeat this for{" "}
          <strong>all three variables in a random order</strong>.
        </li>
      </ul>

      <h4>Advanced Features:</h4>
      <ul>
        <li>
          <strong>Multiple Relationships:</strong> 1-2 variables can have
          relationships (e.g., both B and C might depend on A)
        </li>
        <li>
          <strong>Larger Modifiers:</strong> Relationships can be ±1, ±2, or ±3
          (e.g., "A + 3", "B - 2")
        </li>
        <li>
          <strong>Chain Calculations:</strong> Sometimes you need to calculate
          one variable before you can figure out another
        </li>
      </ul>

      <h4>Example Advanced Round:</h4>
      <ul>
        <li>
          <strong>Displayed Values (one at a time)</strong>
        </li>
        <ul>
          <li>
            A = <strong>2</strong>
          </li>
          <li>
            B = <strong>A + 3</strong> (you calculate: 2 + 3 = 5)
          </li>
          <li>
            C = <strong>B - 1</strong> (you calculate: 5 - 1 = 4)
          </li>
        </ul>
        <li>
          <strong>Question Phase:</strong>
        </li>
        <ul>
          <li>
            The screen asks: <strong>"B = ?"</strong> → You enter{" "}
            <strong>5</strong>
          </li>
          <li>
            The screen asks: <strong>"C = ?"</strong> → You enter{" "}
            <strong>4</strong>
          </li>
          <li>
            The screen asks: <strong>"A = ?"</strong> → You enter{" "}
            <strong>2</strong>
          </li>
        </ul>
        <li>
          <strong>Your score is calculated based on correct answers.</strong>
        </li>
      </ul>

      <h4>Game Rounds</h4>
      <ul>
        <li>
          The game consists of <strong>10 rounds</strong>.
        </li>
        <li>
          Each round has <strong>3 questions</strong> (one for each variable).
        </li>
        <li>
          Maximum score: <strong>30 points</strong> (1 point per correct
          answer).
        </li>
        <li>
          At the end of 10 rounds, your <strong>total score</strong> is
          displayed.
        </li>
      </ul>

      <h4>Tips for Success:</h4>
      <ul>
        <li>
          Calculate relationships <strong>immediately</strong> as they appear -
          don't wait until the question phase!
        </li>
        <li>
          If you see a relationship first (like "A = B - 1"),{" "}
          <strong>remember it</strong> until you see the base value
        </li>
        <li>
          <strong>Mental math is key</strong> - practice adding and subtracting
          1, 2, and 3 quickly
        </li>
        <li>
          <strong>Stay focused</strong> - values disappear quickly (1.5 seconds
          each)
        </li>
        <li>
          For chain calculations, work through them <strong>in order</strong> as
          the values appear
        </li>
      </ul>

      <h3>Ready to test your advanced memory and calculation skills?</h3>

      <Box sx={{ textAlign: "center", marginTop: "1em" }}>
        <Button variant="outlined" onClick={onClick} color="inherit">
          {"Lets Play"}
        </Button>
      </Box>
    </div>
  );
};
export default AdvancedVariableGameInfo;
